import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getServiceCategories } from "../../../api/service";

export const fetchCategories = createAsyncThunk("fetchCategories", async () => {
  const res = await getServiceCategories();
  return res;
});

const initialState = {};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export const { reset } = categorySlice.actions;
export { categorySlice };
